import proj4 from "proj4";
import {register} from "ol/proj/proj4";
import {boundingExtent} from "ol/extent";
import {get as getProjection, transformExtent} from "ol/proj";

import Tile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";

proj4.defs(
    "EPSG:28992",
    "+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +towgs84=565.417,50.3319,465.552,-0.398957,0.343988,-1.8774,4.0725 +units=m +no_defs"
);
proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

register(proj4);

/**
 * Modul Layers
 * 
 * Hier werden alle notwendigen Layer initialisiert und asl Promise objekt
 * zurueckgegeben. Promise weil wir erst mit fetch das capabilities Objekt von
 * geodata.nationaalgeoregister.nl holen muessen
 */

const TOPO_WMS = "https://portal.prvlimburg.nl/geodata/TOPOGRAFIE/wms"
const TOPO_LAYER_NAME = "Actueel_achtergrondkaart"
const TOPO_LAYER_TITLE = "Topografie"
const TOPO_PREVIEW = TOPO_WMS + "?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=" + TOPO_LAYER_NAME + "&WIDTH=256&HEIGHT=256&CRS=EPSG%3A28992&STYLES=&BBOX=175913.76595818624%2C318232.88911185786%2C176524.57764554105%2C318843.7007992127"

const LUCHTFOTO_WMS = "https://portal.prvlimburg.nl/geodata/LUCHTFOTO/wms"
const LUCHTFOTO_LAYER_NAME = "LUFO_ACTUEEL_LAAG"
const LUCHTFOTO_LAYER_TITLE = "Luchtfoto"
const LUCHTFOTO_PREVIEW = LUCHTFOTO_WMS + "?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=" + LUCHTFOTO_LAYER_NAME + "&WIDTH=256&HEIGHT=256&CRS=EPSG%3A28992&STYLES=&BBOX=176524.57764554024%2C318843.7007992156%2C177135.38933289505%2C319454.5124865704"


var layerext = boundingExtent([[-1.65729160235, 48.0405018704],
[12.4317272654, 56.1105896442]]);

layerext = transformExtent(layerext, getProjection("EPSG:4326"), getProjection("EPSG:28992"));

export function createBaseLayers() {
    var layers = []

    layers.push(new Tile({
        title: TOPO_LAYER_TITLE,
        preview: TOPO_PREVIEW,
        baseLayer: true,
        visible: true,
        extent: layerext,
        opacity: 1,
        source: new TileWMS({
            url: TOPO_WMS,
            params: {
                'LAYERS': TOPO_LAYER_NAME
            },
            ratio: 1,
            serverType: 'geoserver'
        })
    }))

    layers.push(new Tile({
        title: LUCHTFOTO_LAYER_TITLE,
        preview: LUCHTFOTO_PREVIEW,
        baseLayer: true,
        visible: false,
        extent: layerext,
        opacity: 1,
        source: new TileWMS({
            url: LUCHTFOTO_WMS,
            params: {
                'LAYERS': LUCHTFOTO_LAYER_NAME
            },
            ratio: 1,
            serverType: 'geoserver'
        })
    }))

    return layers;
}


